import { Service } from '@/services/api';

export interface User {
  id: number;
  userSubId: string;
  userName: string | null;
  userEmail: string;
  userTypeId: number;
  name: string | null;
  phone: string | null;
  mfaEnabled: boolean;
  sourceEmployeeKey: string;
}

class UserService extends Service {
  async resetUserPassword(userId: number): Promise<void> {
    return this.post<void>(`/v2/users/${userId}/reset-password`, undefined).then(this.handleResponse);
  }

  async getEmployeeUsers(employeeKeys: string[]): Promise<User[]> {
    return this.get<User[]>(`/v2/users`, { employeeKeys }).then(this.handleResponse);
  }

  async getAllEmployeeUsers(): Promise<User[]> {
    return this.get<User[]>(`/v2/users`).then(this.handleResponse);
  }

  async getAllUsers(): Promise<User[]> {
    return this.get<User[]>(`/v2/users/all`).then(this.handleResponse);
  }
}

export default new UserService();
